export default __webpack_public_path__ + "static/media/General's Gauntlets of the Watchtowers.fd6b7393.jpg";